import settingsFragment from '../fragments/settings.graphql'

export default {
  name: 'getSettings',
  body: `
    settings {
      ...SettingsFragment
    }
  `,
  fragments: [settingsFragment]
}